/**
 * 滚动到页面顶部的工具函数
 * 支持多种滚动容器和浏览器兼容性
 */
export function scrollToTop() {
  // 方法1: window.scrollTo
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
  });

  // 方法2: 兼容性更好的方式
  window.scrollTo(0, 0);

  // 方法3: 直接设置 scrollTop
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;

  // 方法4: 滚动到 TDesign Layout 的 content 容器
  const contentElement = document.querySelector('.t-layout__content');
  if (contentElement) {
    contentElement.scrollTop = 0;
  }

  // 方法5: 滚动到所有可能的容器
  const scrollableElements = document.querySelectorAll('.t-layout__content, .page-container, .content');
  scrollableElements.forEach(element => {
    if (element.scrollTop !== undefined) {
      element.scrollTop = 0;
    }
  });
}

/**
 * 延迟滚动到顶部，等待 DOM 更新完成
 */
export function scrollToTopDelayed(delay = 100) {
  setTimeout(() => {
    scrollToTop();
  }, delay);
} 